import { map } from "nanostores"
import { useStore } from "./use-store"

type Offers = "monthly" | "yearly"

type UserStore = {
  offer: Offers
  premium?: boolean
  signedIn?: boolean
  forcedCurrency?: string
  paymentDone?: boolean
  email?: string
  isoCountry?: string
  newPassword?: string
  confirmPassword?: string
}

export const $user = map<UserStore>({
  offer: "yearly",
})

// $user.listen((store, key) => {
//   // eslint-disable-next-line no-console
//   console.log(key, store[key])
// })

export const useUser = () => useStore($user)
